"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationOverview = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/*
 * LocationOverview.tsx
 * Author: lnappenfeld
 * Date: 31.08.2022
 *
 * Copyright: DMT GmbH & Co. KG
 */
const react_1 = require("react");
// @ts-ignore
const CustomDataTable_1 = require("./CustomDataTable");
const react_i18next_1 = require("react-i18next");
const CustomConfirmDialog_1 = require("./CustomConfirmDialog");
const CustomToast_1 = require("./CustomToast");
const filter_1 = require("./filter");
const Global_1 = require("../functions/Global");
const api_1 = require("primereact/api");
const LocationOverview = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)(['common', 'metrology']);
    const [locations, setLocations] = (0, react_1.useState)([]);
    // arrays for filter dropdowns
    const [projectGroups, setProjectGroups] = (0, react_1.useState)([]);
    const [epsgCodes, setEpsgCodes] = (0, react_1.useState)([]);
    const [dataLoaded, setDataLoaded] = (0, react_1.useState)(false);
    const _setLocations = () => {
        (0, Global_1.getLocations)(props.project.id, props.keycloakfetch, props.settings).then(result => {
            setLocations(result);
            setDataLoaded(true);
        });
    };
    const _setProjectGroups = () => {
        (0, Global_1.getProjectGroups)(props.project.id, props.keycloakfetch, props.settings).then(result => {
            setProjectGroups(result);
        });
    };
    const _setEpsgCodes = () => {
        (0, Global_1.getEPSGCodes)(props.project.id, props.keycloakfetch, props.settings).then(result => {
            const tmp = [];
            result.forEach((key) => {
                tmp.push({
                    value: key.code,
                    name: key.name,
                });
            });
            setEpsgCodes(tmp);
        });
    };
    (0, react_1.useEffect)(() => {
        _setProjectGroups();
        _setEpsgCodes();
        _setLocations();
    }, [props.selectedLocations]);
    (0, react_1.useEffect)(() => {
        // Lade neu, z.B. wenn Elemente gelöscht wurden
        if (props.reload) {
            _setLocations();
            if (props.setReload)
                props.setReload(false);
        }
    }, [props.reload]);
    const filterCheckboxIsVisible = (options) => {
        return (0, filter_1.filterTriStateCheckBox)(options, t('showAll'), t('visible'), t('hidden'));
    };
    const columns = [{
            field: 'is_visible',
            header: t('visible'),
            filter: true,
            filterElement: filterCheckboxIsVisible,
            style: { maxWidth: '120px' }
        }, {
            field: 'location_name',
            header: t('name'),
            filter: true
        }, {
            field: 'project_group_name',
            header: t('projM_projectGroup'),
            filter: true,
            filterField: 'project_group_id',
            filterDropdownValues: projectGroups
        }, {
            field: 'location_description',
            header: t('description'),
            filter: false
        }, {
            field: 'geo_position',
            header: t('units_position'),
            filter: false
        }, {
            field: 'epsg_code_name',
            header: t('loc_attribs_epsg'),
            filter: true,
            filterField: 'epsg_code',
            filterDropdownValues: epsgCodes
        }];
    const filters = {
        'is_visible': {
            operator: api_1.FilterOperator.AND,
            constraints: [{ value: true, matchMode: api_1.FilterMatchMode.EQUALS }]
        },
        'project_group_id': {
            operator: api_1.FilterOperator.AND,
            constraints: [{ value: null, matchMode: api_1.FilterMatchMode.IN }]
        },
        'location_name': {
            operator: api_1.FilterOperator.AND,
            constraints: [{ value: null, matchMode: api_1.FilterMatchMode.CONTAINS }]
        },
        'epsg_code': {
            operator: api_1.FilterOperator.AND,
            constraints: [{ value: null, matchMode: api_1.FilterMatchMode.IN }]
        }
    };
    if (props.project.project_groups.length === 1) {
        delete columns[2];
    }
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(CustomDataTable_1.CustomDataTable, { id: 'locations', selectionMode: 'multiple', columns: columns, editable: true, sortable: true, value: locations, selection: props.selectedLocations, onSelectionChange: (e) => {
                if (props.setSelectedLocations)
                    props.setSelectedLocations(e.value);
            }, onRemoveClick: (data) => {
                (0, CustomConfirmDialog_1.CustomConfirmDialog)({
                    message: t('dialog_deleteLocationDialog'),
                    header: t('confirmation'),
                    translation: t,
                    onConfirm: () => {
                        (0, Global_1.deleteLocation)(props.project.id, [data.location_id], props.keycloakfetch, props.settings).then(result => {
                            if (result.error) {
                                (0, CustomToast_1.showMessageOnError)(t('error'), t('errorMessages:' + result.error));
                            }
                            else {
                                _setLocations();
                                (0, CustomToast_1.showMessageOnSuccess)(t('success'), t('locations:toasts.locationDeleted'));
                            }
                        });
                    }
                });
            }, onEditClick: (data) => {
                if (props.setSelectedLocations)
                    props.setSelectedLocations([data]);
                if (props.setEditLocation)
                    props.setEditLocation(true);
            }, ableToDelete: true, ableToUpdate: true, filters: filters, dataloaded: dataLoaded, settings: props.settings, keycloakfetch: props.keycloakfetch }) }));
};
exports.LocationOverview = LocationOverview;
